import type { IconSvgObject } from './types';

const StrokeBottomIcon: IconSvgObject = [
  ["path", { d: "M5 17V9C5 6.17157 5 4.75736 5.87868 3.87868C6.75736 3 8.17157 3 11 3H13C15.8284 3 17.2426 3 18.1213 3.87868C19 4.75736 19 6.17157 19 9V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 21L21 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default StrokeBottomIcon;
